import { Space } from "antd";

export const Planscolumns2 = (setAmount) => {
  return [
    {
      title: "Circle",
      dataIndex: "circleId",
      key: "circleId",
      render: (text) => <a className="font-medium">{text}</a>,
    },
    {
      title: "Plan",
      dataIndex: "rechargeType",
      key: "rechargeType",
      render: (text) => {
        return (
          <>
            <p className=" font-medium px-3 overflow-y-scroll">
              {text ? text.split(" ")[0] : "NAN"}
            </p>
          </>
        );
      },
    },

    {
      title: "Validity",
      dataIndex: "validity",
      key: "validity",
      render: (text) => <a className="font-medium">{text}</a>,
    },
    {
      title: "Description",
      dataIndex: "longDesc",
      key: "longDesc",
      render: (text) => {
        return (
          <>
            <p
              style={{ width: "300px" }}
              className="font-medium   px-3 overflow-y-scroll"
            >
              {text ? text : "NAN"}
            </p>
          </>
        );
      },
    },

    {
      title: "Price",
      key: "amount",
      dataIndex: "amount",
      render: (text) => {
        return (
          <p
            onClick={() => setAmount(text)}
            className="border  cursor-pointer border-primary hover:bg-primary hover:text-bswhite font-bold transition-all text-center px-2 text-primary rounded-md"
          >
            RS. {text}
          </p>
        );
      },
    },
  ];
};
